export const RESUME = {
    title: "Resume",
    subtitle: "My",
    typeWriter: ["Education", "Experience"],
    education: [
        {
            year: "2017 - 2018",
            institution: "Alexander Model Govt. High School",
            subject: "Science",
            description: "Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
            year: "2018 - 2019",
            institution: "ASM Abdur Rob Govt. Collage",
            subject: "Science",
            description: "Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
            year: "2019 - present",
            institution: "Bhola Polytechnic Institute",
            subject: "Computer Science & Technology",
            description: "Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
    ],
    experience: [
        {
            year: "2022 - Present",
            company: "KS Devware",
            role: "Fronted Web Developer",
            description: "Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        
    ],
    skills: [
        {
            name: "Web Design",
            parentage: 90
        },
        {
            name: "Frontend Development",
            parentage: 80
        },
        {
            name: "React Js",
            parentage: 80
        },
        {
            name: "UI/UX Design",
            parentage: 90
        },
        {
            name: "Google Firebase",
            parentage: 80
        },
        {
            name: "Photography",
            parentage: 70
        },
    ]
}